import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Mic, Headphones, Radio } from "lucide-react";
import MobileTitleSpacer from "../components/MobileTitleSpacer";
import SEO from '../components/SEO';
import { seoConfig } from '../utils/seoConfig';

const Studio = () => {
  const services = [
    { 
      icon: Mic, 
      title: "Enregistrement", 
      description: "Voix, guitares & basses, autres petits instruments" 
    },
    { 
      icon: Headphones, 
      title: "Mixage", 
      description: "Mixage audio stéréo pour projets musicaux et audiovisuels" 
    },
    {
      icon: Radio,
      title: "Post-Production",
      description: "Montage, nettoyage, sound design, bruitage, synchronisation",
    },
  ];

  return (
    <>
      <SEO 
        title={seoConfig.studio.title}
        description={seoConfig.studio.description}
        keywords={seoConfig.studio.keywords}
        url={seoConfig.studio.url}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen bg-black pt-20"
      >
        {/* HEADER AVEC PHOTO EN FOND */}
        <div className="relative overflow-hidden">
        {/* Photo de fond subtile */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/images/STUDIO.jpg')",
            opacity: 1,
            filter: "blur(3px)",
          }}
        />

        {/* Overlay sombre pour lisibilité */}
        <div className="absolute inset-0 bg-black/50" />

        {/* Contenu du header */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
          <MobileTitleSpacer height="50px" />

          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4"
            style={{ color: "#22c55e" }}
          >
            STUDIO
          </h1>

          <div
            className="h-1 w-32 md:w-40 mb-6"
            style={{
              background: "linear-gradient(to right, #22c55e, transparent)",
            }}
          />

          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl">
            Studio d'enregistrement voix et production audio à Lyon.
          </p>
        </div>
      </div>

      {/* SERVICES */}
      <section className="w-full px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 md:pt-10 pb-14 md:pb-20">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-8 text-center">
            Services
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
            {services.map(({ icon: Icon, title, description }, i) => (
              <div
                key={i}
                className="group rounded-2xl p-6 border-2 transition-transform duration-300 hover:scale-[1.02]"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(0,255,0,0.06) 0%, rgba(0,0,0,0.9) 100%)",
                  borderColor: "rgba(20,255,24,0.25)",
                  boxShadow: "0 0 22px rgba(20,255,24,0.12)",
                }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <Icon size={22} className="text-green-400" />
                  <h3 className="text-white text-lg font-bold">{title}</h3>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/contact"
              className="inline-block text-lg sm:text-xl font-bold text-green-400 hover:text-green-300 transition-colors duration-200"
            >
              Tarifs sur demande
            </Link>
          </div>
        </div>
      </section>
      </motion.div>
    </>
  );
};

export default Studio;